import { MouseEventHandler } from 'react';
import { Button, IconProps } from '@southfields-digital/mpxlive-components';

type Props = {
  title: string;
  icon: IconProps['icon'];
  weight?: IconProps['weight'];
  onClick: MouseEventHandler;
};

export default function ActionButton({ title, icon, weight = 'bold', onClick }: Props) {
  return (
    <Button
      as="button"
      variant="iconButton"
      title={title}
      iconProps={{ icon, size: 14, color: '#C9C9CD', weight }}
      onClick={onClick}
      className="!py-1 !bg-elevated-2 hover:!bg-blue-600"
    />
  );
}
